export const DEFAULT_BUTTON_TITLE = 'Select color'
